import RestAPI from 'components/Common/restApi';

import { LocalStorage } from '../../components/Common/Utils/local_storage';

import { SB_KEY } from './Data';

async function refreshToken() {
  if (SENDBIRD.enabled) {
    try {
      const { data } = await RestAPI.get('/alpha/organization/sendbird/token');
      if (data && data.token && data.expires_at) {
        if (LocalStorage.isStorageEnabled()) {
          LocalStorage.setItem(SB_KEY, JSON.stringify({ ...data }));
        }
        return data.token;
      }
      return null;
    } catch (error) {
      throw new Error('Error while geting a new Sendbird Token');
    }
  }
  return null;
}

export default refreshToken;
